import * as React from "react";
const SvgUserPlaceholder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#89909D"
      d="M40.128 51.19c-15.221 0-28.758 7.35-37.375 18.755C.898 72.4-.03 73.628 0 75.286c.023 1.282.828 2.898 1.836 3.69C3.142 80 4.951 80 8.568 80h63.12c3.617 0 5.425 0 6.73-1.024 1.009-.791 1.813-2.408 1.837-3.69.03-1.659-.897-2.886-2.752-5.34C68.885 58.54 55.349 51.19 40.128 51.19M40.128 43.214c11.933 0 21.607-9.674 21.607-21.607S52.06 0 40.128 0 18.52 9.674 18.52 21.607s9.674 21.607 21.607 21.607"
    />
  </svg>
);
export default SvgUserPlaceholder;
